import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { setSelectedAttribute } from 'src/module/filter/action';
import { updateUserPreferences } from 'src/module/user/preferences';


export default function useSwitchChemelexUi () {
  const dispatch = useDispatch();

  return useCallback((useChemelexUi: boolean) => {
    dispatch(updateUserPreferences({ useChemelexUi }));
    dispatch(setSelectedAttribute(null));
  }, [dispatch]);
}
